export default "__VITE_ASSET__CaGDT7Qg__"